import React from 'react';
import { ScrollView, Platform } from 'react-native';
import { Card } from 'react-native-paper';
import CustomButton from '../../CustomButton/CustomButton';
import { StyleSheet, SafeAreaView } from 'react-native';
// import CustomIconButton from '../CustomButton/CustomIconButton';
import CustomQuestion from '../Questions/CustomQuestions';
import CustomInput from '../../CustomInput/CustomInput';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

import PopUp from '../PopUp/PopUp'

// import sx from "mui-sx";
// import {sxTextField} from '../../pages/css/sx';

const CustomSection = ({ setQuestion, question, sectionTitleChange, textFieldSectionName, sectionName = "", sectionId, handleQuestionRatingOptionAdd, handleQuestionRatingOptionChange, handleQuestionRatingOptionRemove,
    sectionQuestionList, handleQuestionAdd, handleQuestionChange, handleQuestionAddFromSurvey, handleQuestionRemove, sectionIndex, handleQuestionTypeChange, handleQuestionOptionAdd,
    handleQuestionOptionChange, questionOptionResponseList, chartOptions, chartData, noOfUsers, handleQuestionOptionRemove, isResponse = 0, isResult = 0, isAnalytics = 0, }) => {

    const { colors } = useTheme()
    const styles = makeStyles(colors)
    const { t, i18n } = useTranslation();
    return (
        <SafeAreaView style={styles.mainView}
            noValidate
            autoComplete="off" >
            {/* Name of the Section */}
            < CustomInput
                value={sectionName === "" ? "" : sectionName }
                editable={isResponse == 1 ? false : true}
                setValue={sectionTitleChange}
                type='SURVEYHEADER1'
                placeholder={sectionName === "" ? t("common:sectiontitle") : sectionName}
            />
            <SafeAreaView>
                {sectionQuestionList.map((singleQuestion, index) => (
                    <Card key={index} style={styles.cardstyle}>
                        <Card.Content>
                            <CustomQuestion
                                qType={question}
                                setQType={setQuestion}
                                textFieldQuestionName="question_name"
                                questionName={singleQuestion.question_name}
                                questionId={singleQuestion.id}
                                questionIndex={index}
                                sectionId={sectionId}
                                sectionIndex={sectionIndex}
                                handleQuestionChange={handleQuestionChange}
                                handleQuestionTypeChange={handleQuestionTypeChange}
                                handleQuestionRatingOptionRemove={handleQuestionRatingOptionRemove}
                                input_type_name={singleQuestion.input_type_name}
                                allow_mutiple_option_answers_yn={singleQuestion.allow_mutiple_option_answers_yn}
                                question_required_yn={singleQuestion.question_required_yn}
                                questionOption={singleQuestion.question_options}
                                handleQuestionOptionAdd={handleQuestionOptionAdd}
                                handleQuestionOptionChange={handleQuestionOptionChange}
                                questionOptionResponseList={questionOptionResponseList}
                                handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                                chartOptions={chartOptions}
                                chartData={chartData}
                                noOfUsers={noOfUsers}
                                handleQuestionOptionRemove={handleQuestionOptionRemove}
                                handleQuestionRatingOptionAdd={handleQuestionRatingOptionAdd}
                                isResponse={isResponse}
                                isResult={isResult}
                                isAnalytics={isAnalytics}
                            />
                            {!isResponse &&
                                <SafeAreaView className="customButtonRight">
                                    {sectionQuestionList.length !== 1 && (
                                        <CustomButton
                                            onPress={() => handleQuestionRemove(index, sectionIndex)}
                                            iconName='trash-outline'
                                            show='HOME_BELL'
                                            type='HOME_BELL'
                                            textTop='0'
                                            sz={30}
                                        />
                                    )}
                                </SafeAreaView>
                            }
                        </Card.Content>
                        <Card.Actions>
                            <SafeAreaView style={styles.questionButtonsx}>
                                {/* //* Limit the number of sections, when maximume section number is reached the button disappears   */}
                                {!isResponse && (sectionQuestionList.length - 1 === index && sectionQuestionList.length < 4) && (
                                    <PopUp
                                        index={index}
                                        handleAdd={() => handleQuestionAdd(index, sectionIndex)}
                                        sectionIndex={sectionIndex}
                                        setClickListener={handleQuestionAddFromSurvey}
                                    />
                                )}
                            </SafeAreaView>
                        </Card.Actions>
                    </Card>
                ))
                }
            </SafeAreaView>
        </SafeAreaView >
    )
};

const makeStyles = (colors) => StyleSheet.create({
    main: {
        alignContent: 'center',
    },

    cardstyle: {
        borderWidth: 0,
        elevation:0,
        padding:  Platform.OS === 'web' ? 10 : 5,
        margin: 10,
        borderRadius: 35,
        backgroundColor: colors.background_card,
    },
    row: {
        flexDirection: "row"
    },
});

export default CustomSection;